<template>
    <DFormRow
        :label="__('customers.contracts.reseller_cloudpit_account_id')"
        :error="errors.reseller_cloudpit_account_id"
    >
        <DInput
            id="reseller_cloudpit_account_id"
            :model-value="modelValue"
            type="number"
            min="1"
            max="4294967295"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'ResellerAccount',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['update:modelValue']
}
</script>
